import { CUSTOMERS_LIST_API, TAGS_API, TAGS_LIST_API } from "../../../../constants/Configs"
import { API_REQUEST } from "../../../../constants/General"
import { Actions } from "../../../../redux/actions"
import API from "../../../../services/api"
import { getPageSize } from "../../../../services/middleware"
import { dispatch } from "../../../../utils/store"
import { handleError, handleSuccess } from "../../../../utils/toast"
import { customersListDTO } from "../dtos/customers"
import { tagsListDTO } from "../dtos/tags"

export const getTags = (search, sortBy, orderBy, page = 1) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  const params = {
    ...(!!search ? { search } : {}),
    ...(!!sortBy ? { sortBy } : {}),
    ...(!!orderBy ? { orderBy } : {}),
    ...(!!page ? { page, 'size': getPageSize() } : {}),
  }

  API(API_REQUEST.get, TAGS_LIST_API, { params })
    .then(res => {
      dispatch(Actions.RestaurantAdminTags.SetTags, tagsListDTO(res?.data?.data?.rows))
      dispatch(Actions.RestaurantAdminTags.SetTotalCount, res.data.data.count)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const getTag = async (id) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  return await API(API_REQUEST.get, `${TAGS_API}/${id}`)
    .then((res) => {
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
      return res?.data?.data || []
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
      return []
    })
}

export const addTag = (data, search, activeSort, sortOrder, page, handleCloseAddModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.post, TAGS_API, data)
    .then((res) => {
      handleSuccess(res)
      handleCloseAddModal()
      getTags(search, activeSort, sortOrder, page)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch((error) => {
      handleError(error);
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const editTag = (id, data, search, activeSort, sortOrder, page, handleCloseEditModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.put, `${TAGS_API}/${id}`, data)
    .then(res => {
      handleSuccess(res)
      handleCloseEditModal()
      getTags(search, activeSort, sortOrder, page)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const deleteTag = (id, search, activeSort, sortOrder, page, handleCloseDeleteModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.delete, `${TAGS_API}/${id}`)
    .then(res => {
      handleSuccess(res)
      handleCloseDeleteModal(false)
      getTags(search, activeSort, sortOrder, page)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const getCustomers = async () => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  const params = {
    page: 1, size: 10000
  }

  await API(API_REQUEST.get, CUSTOMERS_LIST_API, { params })
    .then(res => {
      const customers = customersListDTO(res.data.data.rows)?.map((customer) => {
        return {
          label: customer?.customer?.name,
          value: customer?.customer?.id
        }
      })
      dispatch(Actions.RestaurantAdminTags.SetCustomers, customers)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}
